import PropTypes from 'prop-types';

const PendingAISummaryBannerView = ({ localisedValues, count }) => {
    return (
        <div className="recording-load-file">
            <div className="recording-load-file-in">
                <div className="recording-load-left">
                    <span className="for-icon icon-loader spin"></span>
                </div>
                <div className="recording-load-right">
                    <p>
                        {localisedValues?.summaries_processed_view_label
                            .replace("<count>", count)
                            .replace("<text>", count > 1 ? localisedValues?.summaries : localisedValues?.summary)}
                    </p>
                </div>
            </div>
        </div>
    )
}

PendingAISummaryBannerView.propTypes = {
    localisedValues: PropTypes.object,
    count: PropTypes.any,
};

export default PendingAISummaryBannerView
